import { createFileRoute } from '@tanstack/react-router';

import { CertificationLevels } from '@/features/certifications/CertificationLevels';

export const Route = createFileRoute('/certification-levels/')({
  component: CertificationLevels,
});
